import React from 'react';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';
import { FeatureFlagsProvider } from './FeatureFlags';
import { CurrentUserProvider } from './CurrentUser';
import { ExperimentationProvider } from './Experimentation';

export function AppProviders({ children }: { children: JSX.Element }) {
  return (
    <CurrentUserProvider>
      <ExperimentationProvider>
        <FeatureFlagsProvider>
          <UnsavedChangesWarningProvider>
            <NetworkRoleProvider>
              <BrowserSizeProvider>{children}</BrowserSizeProvider>
            </NetworkRoleProvider>
          </UnsavedChangesWarningProvider>
        </FeatureFlagsProvider>
      </ExperimentationProvider>
    </CurrentUserProvider>
  );
}
